import { Icon } from '@dealstack/frontend/shared/components/fundament/Icon/Icon';
import { defaultTheme } from '@dealstack/frontend/shared/mechanism/styleguide/defaultTheme';
import { Button, Checkbox, Text, rem } from '@mantine/core';
import { useState } from 'react';
import styled from 'styled-components';

interface Props {
	className?: string;
	checkboxText: string;
	buttonText: string;
	buttonAction: () => void;
}

const RemoveInvestorBox = ({ className, checkboxText, buttonText, buttonAction }: Props) => {
	const [checked, setChecked] = useState(false);
	return (
		<div className={className}>
			<Checkbox
				label={
					<Text fz={14} fw={600}>
						{checkboxText}
					</Text>
				}
				style={{ marginBottom: '0.5rem' }}
				styles={{ input: { cursor: 'pointer' } }}
				onChange={(event) => setChecked(event.currentTarget.checked)}
			/>
			<Button
				variant="deletion"
				leftSection={<Icon variant="trash-can" />}
				size="md"
				disabled={!checked}
				onClick={buttonAction}
				sx={{ marginLeft: '1.7rem' }}
			>
				{buttonText}
			</Button>
		</div>
	);
};

const Styled = styled(RemoveInvestorBox)`
	background-color: ${defaultTheme.v2.color.error[200]};
	padding: 1rem;
	width: ${rem(960)};
	border-radius: 0.5rem;
`;

export { Styled as RemoveInvestorBox };
